import { render, staticRenderFns } from "./EditPhieuChi.vue?vue&type=template&id=17c859ec&"
import script from "./EditPhieuChi.vue?vue&type=script&lang=js&"
export * from "./EditPhieuChi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports